import React from "react";
import {
  H4_ABOUT_IMG01,
  H4_ABOUT_IMG02,
  H4_ABOUT_SHAPE,
} from "../../lib/assets";
import { Odometer } from "../Odometer/Odometer";

export const AboutTen = () => {
  return (
    <section className="about-area-ten">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="about-img-wrap-five about-img-wrap-ten">
              <img src={H4_ABOUT_IMG01} alt="" style={{height:"400px"}}/>
              <img src={H4_ABOUT_IMG02} alt="" data-parallax='{"y" : 100 }' />
              <div className="experience-wrap">
                <h2 className="title">
                  25 <span>Years Of Experience</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content-five about-content-ten">
              <div className="section-title-two mb-30">
                <span className="sub-title">Get To know US</span>
                <h2 className="title">
                Empowering Businesses to Elevate Standards and Achieve Excellence.
                </h2>
              </div>
              <p>
             {/* At TMC, our mission is to enhance organizational systems through comprehensive 
              consultancy services. We deliver tailored solutions across various industries, 
              including manufacturing, education, and construction.
*/}
               At TMC, our mission is to empower organizations to achieve excellence through effective
               management systems. We provide comprehensive consultancy services, from strategy 
               development to end-to-end system implementation, across various sectors including 
               manufacturing, education, logistics, construction, retail, and more.
              </p>
              <p>
            
             {/* Our experienced team creates customized documentation that aligns with your 
              performance needs, ensuring effective management system standards. Partner with us 
              to achieve improvements in quality, service delivery, environmental responsibility,
               and occupational health and safety, surpassing customer expectations and setting
                new excellence benchmarks.*/}
                Our team of seasoned consultants leverages their extensive experience to 
                design and develop tailored documentation that aligns with your organization's unique 
                needs and management system standards. Our goal is to help 
                you achieve measurable improvements in quality, service, delivery, environmental 
                responsibility, occupational health and safety, and ultimately, exceed customer 
                satisfaction expectations.
              </p>
              <div className="about-success-wrap">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <i className="flaticon-family"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={100} />%
                      </h2>
                      <p>Happy Customers</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="flaticon-trophy"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={100} />%
                      </h2>
                      <p>deadline achieved</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-shape-five">
        <img src={H4_ABOUT_SHAPE} alt="" />
      </div>
    </section>
  );
};
